import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60687522")

_pushScopeId("data-v-60687522")
const _hoisted_1 = { class: "btn-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.ImportRfCardAndPin,
    footerType: "customize",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    width: "426px",
    "custom-class": "custom-el-dialog"
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_cus_button, {
          type: "blue",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('import')))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.RDeiviceImport), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_cus_button, { onClick: _ctx.download }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.DownloadImportTemplate), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})